import { FC, ReactElement, memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { emptyArray } from '~/utils/helpers';

export const PreviousOrderModalProductSkeleton: FC = memo((): ReactElement => {
  return (
    <div className="previous-order-modal-product">
      <Skeleton width={95} height={61} style={{ borderRadius: 12 }} />

      <div className="d-flex flex-row flex-1 justify-content-between">
        <div className="d-flex flex-column">
          <Skeleton width={100} height={21.6} className="mb-2" />

          {emptyArray().map((_, index) => (
            <Skeleton key={index} width={130} height={12} />
          ))}
        </div>

        <Skeleton width={50} height={14.4} />
      </div>
    </div>
  );
});
